<template>
  <div>
    <div class="header">
      <div class="header_title">新零售绩效提成核算</div>
    </div>
    <div class="performance-page">
      <div class="page-header">
        <div class="action-title">{{ taskTitle }}</div>
        <div class="action-buttons">
          <el-button
            v-if="[0,3].includes(status) "
            type="primary"
            icon="el-icon-upload2"
            size="medium"
            class="import-btn"
            @click="handleImport"
            >导入数据</el-button
          >
          <el-button
            icon="el-icon-download"
            type="primary"
            size="medium"
            class="export-btn"
            @click="handleExprot"
            >导出数据</el-button
          >

          <el-button
            v-if="[0,3].includes(status) "
            type="primary"
            size="medium"
            icon="el-icon-check"
            class="confirm-btn"
            @click="handleSubmit"
          >
            确认数据</el-button
          >
        </div>
      </div>

      <div class="filter-section">
        <el-select
          v-model="pmManager"
          placeholder="请选择"
          clearable
          size="medium"
          style="width: 100%"
          @change="changePM"
        >
          <el-option
            v-for="(item, index) in PMData"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <!-- PM零售负责人表格 -->
      <common-table
        v-show="pmManager == '1'"
        :table-data="performanceData"
        :columns="pmRetailColumns"
        title="运营人员提成汇总表"
        @edit="handleEdit"
        :tableLoading.sync="tableLoading"
        :status.sync="status"
      />
      <!-- 支持部门长表格 -->
      <common-table
        v-show="pmManager == '2'"
        :table-data="performanceData"
        :columns="supportDeptColumns"
        title="支持部门长绩效汇总表"
        :editRate.sync="editrate"
        :show-edit-rate-btn="true"
        @edit="handleEdit"
        @updateEbitda="submitHandleEdit"
        :tableLoading.sync="tableLoading"
        :status.sync="status"
      />

      <!-- 运营提成表格 -->
      <common-table
        v-show="pmManager == '3'"
        :table-data="performanceData"
        :columns="operationColumns"
        title="运营人员提成汇总表"
        @edit="handleEdit"
        :tableLoading.sync="tableLoading"
        :status.sync="status"
      />

      <!-- 后端绩效表格 -->
      <common-table
        v-show="pmManager == '4'"
        :table-data="performanceData"
        :columns="backendColumns"
        title="后端支持部门绩效奖金汇总表"
        :editRate.sync="editrate"
        @edit="handleEdit"
        :show-edit-rate-btn="true"
        @updateEbitda="submitHandleEdit"
        :tableLoading.sync="tableLoading"
        :status.sync="status"
      />
    </div>
    <!-- 导入数据 -->
    <upload
      :visible.sync="uploadDialog"
      @success="successUpload"
      :pmManager.sync="pmManager"
      :taskid.sync="taskid"
      :editRate="editrate"
      :dialogTitle.sync="pmManagerText"
    />

    <!-- 4个编辑弹窗 -->
    <edit-dialog
      :visible.sync="dialogVisible"
      :title="dialogConfig.title"
      :current-row="currentRow"
      :read-only-fields="dialogConfig.readOnlyFields"
      :editable-fields="dialogConfig.editableFields"
      @submit="submitHandleEdit"
      @update:visible="(val) => (dialogVisible = val)"
      :isEdit.sync="isDialogEdit"
    ></edit-dialog>
  </div>
</template>
<script>
import api from "@/apis/retail";

import CommonTable from "./components/common-table.vue";
import editDialog from "./components/edit-dialog.vue";
import upload from "./components/upload";
import {
  pmRetailColumns,
  supportDeptColumns,
  operationColumns,
  backendColumns,
} from "./config/tableColumns";
import {
  pmRetailDialogConfig,
  supportDeptDialogConfig,
  operationDialogConfig,
  backendDialogConfig,
} from "./config/dialogConfig";
export default {
  name: "PerformanceSummary",
  components: { editDialog, CommonTable, upload },
  data() {
    return {
      status: null,
      pmRetailColumns, // PM零售负责人列配置
      supportDeptColumns, //支持部门长列配置
      operationColumns, //运营提成列配置
      backendColumns, //后端绩效列配置
      editrate: "100",
      // 筛选条件
      pmManager: "1",
      department: "",
      dateRange: ["2025-01", "2025-03"],
      // 业绩数据
      performanceData: [],
      dialogVisible: false,
      dialogConfig: {},
      pmManagerText:'导入PM零售负责人',
      currentRow: {},
      uploadDialog: false,
      taskid: null,
      tableLoading: false,
      PMData: [
        { label: "PM零售负责人", value: "1" },
        { label: "支持部门长", value: "2" },
        { label: "运营提成", value: "3" },
        { label: "后端绩效", value: "4" },
      ],
      taskTitle:null,
      isDialogEdit:true,//弹框是否可编辑
    };
  },

  created() {
    // 直接从路由的query中获取参数
    const { taskid } = this.$route.query;
    this.taskid = taskid;
    this.getList();
  },
  methods: {
    getTaskDetail() {
      let params = {
        taskid: this.taskid,
      };
      api.getRetailDetail(params).then((res) => {
        if (res.msg == "success") {
          this.status = res.data?.status;
          this.taskTitle=res.data?.name;;

        }
      });
    },
    changePM(val) {
      if (val) {
        this.getList();
        this.pmManagerText = '导入'+this.PMData.find(
          (item) => item.value == val
        ).label;
      }
    },
    getList() {
      this.tableLoading = true;
      let params = {
        type: this.pmManager,
        taskid: this.taskid,
      };
      api.getKpiList(params).then((res) => {
        if (res.msg == "success") {
          this.performanceData = res.data || [];
          if (res.data.length && res.data[0].ebitda) {
            this.editrate = res.data[0].ebitda;
          }
          this.tableLoading = false;
        }
      });
      //获取任务列表详情
      this.getTaskDetail();
    },

    // 确认数据
    handleSubmit() {
      let params = {
        taskid: this.taskid,
      };
      api.confirmData(params).then((res) => {
        if (res.msg == "success") {
          this.$message.success("数据提交成功！");
        }
      });
    },
    handleImport() {
      if (this.pmManager == 2 || this.pmManager == 4) {
        if (!this.editrate) {
          return this.$message.error("EBITDA达成率必填");
        }
      }
      this.uploadDialog = true;
    },
    handleExprot() {
      const params = {
        type: this.pmManager,
        taskid: this.taskid,
      };
      api.downloadData(params).then((res) => {
        console.log(res, "res");

        if (res.code == 1) {
          // window.open(res.data);替换这个
           const link = document.createElement('a');
          link.href = res.data;
          // link.download = 'template.xlsx'; // 设置下载文件名
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    // 修改数据
    submitHandleEdit(row) {
      console.log("在这里");

      let params = {
        ...row,
        id: row.id,
        type: this.pmManager,
      };
      if (!row.id) {
        //:修改ebitda时传,也就是点点击修改 ebitda，而不是点击列表
        params.taskid = this.taskid;
      }

      api.editData(params).then((res) => {
        if (res.msg == "success") {
          this.getList();
          this.$message.success("数据修改成功！");
        }
      });
    },
    // 打开编辑的弹窗
    handleEdit(row,type) {
      this.currentRow = row;
      // 根据当前选择的类型设置对话框配置
      /*
        1：零售负责人；
        2：支持部门长；
        3：运营提成；
        4：后端绩效
      */
     if(type=='查看'){
      // 查看不可编辑
      this.isDialogEdit=false;
     }else{
      this.isDialogEdit=true;

     }
      switch (this.pmManager) {
        case "1":
          this.dialogConfig = pmRetailDialogConfig;
          break;
        case "2":
          this.dialogConfig = supportDeptDialogConfig;
          break;
        case "3":
          this.dialogConfig = operationDialogConfig;
          break;
        case "4":
          this.dialogConfig = backendDialogConfig;
          break;
      }

      this.dialogVisible = true;
    },
    handleSubmit() {
      let params = {
        taskid: this.taskid,
      };
      api.confirmData(params).then((res) => {
        if (res.code == "1") {
          this.getList();
          this.$message.success("数据提交成功！");
        }
      });
    },
    // 导入成功之后更新数据
    successUpload() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  height: 119px;
  width: 100%;
  height: 125px;
  background: url("~@/assets/retail/top.png");
  background-size: 100% 100%;

  .header_title {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 46px;
    color: #107459;
    font-weight: 550;
    line-height: 89px;
  }

  .header-btn {
    display: flex;
    align-items: center;
    position: absolute;
    top: 80px;
    left: 20px;
    transform: translateY(-50%);

    // z-index: 999999;
    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 34px;
      width: 80px;
      border: 1px solid #7db6a5;
      background: none;
      //   margin-right: 10px;
      font-size: 14px;
      background-color: #7db6a5;
    }

    .data-switch {
      // border-radius:20px;
      // border: 1px solid rgba(125, 182, 165, 1);
      display: flex;
      margin-right: 10px;

      // margin-top: 70px;
      .data-type {
        width: 75px;
        height: 34px;
        font-size: 14px;
        font-weight: 400;
        line-height: 32px;
        text-align: center;
        color: rgba(12, 113, 83, 1);
        cursor: pointer;

        &.realtime {
          border-radius: 0 20px 20px 0;
          border: 1px solid rgba(125, 182, 165, 1);
        }

        &.monthly {
          border-radius: 20px 0 0 20px;
          border: 1px solid rgba(125, 182, 165, 1);
        }

        &.active {
          font-weight: bold;
          background: rgba(125, 182, 165, 1);
          // box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.19);
          color: #fff;
        }
      }
    }
  }
}
.performance-page {
  font-size: 32px;
  padding: 0 20px;
  // min-height: 100vh;
}

// 页面标题和操作区
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
  .action-title{
    font-weight: bold;
  }
  .action-buttons {
    display: flex;
    gap: 10px;
    .export-btn,
    .import-btn,
    .confirm-btn {
      transition: all 0.2s ease;
      background: #028d4e;
      border: #028d4e;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

// 筛选区域样式
.filter-section {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
</style>
